import React, { Fragment } from "react"
import { isMerchantOpen } from "../../helpers/IsoDateHelpers"
import ReactHtmlParser from "react-html-parser"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import Svg from "../../shared/_svgs/svg"
import Slider from "react-slick"
import { CarouselItem } from "../itinerary/ItineraryContentBlockCarousel"
import useWindowWidth from "../../hooks/useWindowWidth"

const MerchantInfoModal = ({
  isMerchantModalShown,
  showMerchantInfoModal,
  img,
  name,
  merchantCategories,
  merchantIsNearGate,
  nearGateSplashLabel,
  merchantDescription,
  merchantEmail,
  merchantLink,
  merchantNumber,
  sameMerchants,
  alwaysOpen,
  alwaysOpenLabel,
  merchantPhone,
  openingHours,
  openLabel,
  closedLabel,
  supportsClickAndCollect,
  supportsHomeDelivery,
  homeDeliveryLabel,
  websiteAdress,
  flightGate,
  shopLocation,
  emailCoverLabel,

  clickAndCollectLabel,
  isFlightDateOlderThanToday,
  estimatedPublicTime,
  findAllLabel,
  readMoreLabel,
  readLessLabel,
  openingLabel,
  closingLabel,
  weekdays,
  googleMapsLink,
  googleMapsLinkLabel,
  googleMapsLinkTarget,
}) => {
  const lang = document?.body?.dataset.language || "da"
  const windowWidth = useWindowWidth()

  const openingHoursArray = openingHours && [
    openingHours.MondayOpening,
    openingHours.TuesdayOpening,
    openingHours.WednesdayOpening,
    openingHours.ThursdayOpening,
    openingHours.FridayOpening,
    openingHours.SaturdayOpening,
    openingHours.SundayOpening,
  ]
  const closingHoursArray = openingHours && [
    openingHours.MondayClosing,
    openingHours.TuesdayClosing,
    openingHours.WednesdayClosing,
    openingHours.ThursdayClosing,
    openingHours.FridayClosing,
    openingHours.SaturdayClosing,
    openingHours.SundayClosing,
  ]

  function convertDateIndexToMondayZero(dateIndex) {
    return dateIndex === 0 ? 6 : dateIndex - 1
  }

  const openingHoursForTheDay = openingHoursArray ? openingHoursArray[convertDateIndexToMondayZero(estimatedPublicTime.weekday)] : null
  const closingHoursForTheDay = closingHoursArray ? closingHoursArray[convertDateIndexToMondayZero(estimatedPublicTime.weekday)] : null

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
  function FormatOpeningHoursTable(fromTimeArray, toTimeArray) {
    let formattedRanges = []

    for (let i = 0; i < fromTimeArray.length; i++) {
      formattedRanges.push(fromTimeArray[i] + " - " + toTimeArray[i])
    }
    return formattedRanges
  }

  function getOpeningHoursListWithFlightDayFirst() {
    // starting with flightDate and looping over the week with monday as index 0 and sunday as index 6 build the list of opening hours
    let openingHoursList = []
    const weeklyOpeningHours = FormatOpeningHoursTable(openingHoursArray, closingHoursArray)
    const flightDayNumber = convertDateIndexToMondayZero(estimatedPublicTime.weekday)
    openingHoursList.push(
      <div key={weekdays[flightDayNumber]} className="day">
        <div className="day-container">
          <strong>
            <p className="day-name">{capitalizeFirstLetter(weekdays[flightDayNumber])}</p>
          </strong>
          <strong>
            <p className="day-opening-hour">{weeklyOpeningHours[flightDayNumber]}</p>
          </strong>
        </div>
      </div>,
    )
    for (let i = flightDayNumber + 1; i < 7; i++) {
      openingHoursList.push(
        <div key={weekdays[i]} className="day">
          <div className="day-container">
            <p className="day-name">{capitalizeFirstLetter(weekdays[i])}</p>
            <p className="day-opening-hour">{weeklyOpeningHours[i]}</p>
          </div>
        </div>,
      )
    }

    for (let i = 0; i < flightDayNumber; i++) {
      openingHoursList.push(
        <div key={weekdays[i]} className="day">
          <div className="day-container">
            <p className="day-name">{capitalizeFirstLetter(weekdays[i])}</p>
            <p className="day-opening-hour">{weeklyOpeningHours[i]}</p>
          </div>
        </div>,
      )
    }
    return openingHoursList
  }

  //check if merchant is open
  const merchantIsOpen = alwaysOpen || isMerchantOpen(openingHoursForTheDay, closingHoursForTheDay, lang)

  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 550,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  }

  const sameMerchantsSlider = sameMerchants.map((slide, i) => {
    return (
      <CarouselItem
        key={i}
        alwaysOpen={slide.AlwaysOpen}
        alwaysOpenLabel={slide.AlwaysOpenLabel}
        closedLabel={slide.ClosedLabel}
        img={slide.Image}
        categories={slide.MerchantCategories}
        merchantDescription={slide.MerchantDescription}
        merchantEmail={slide.MerchantEmail}
        link={slide.MerchantLink}
        merchantNumber={slide.MerchantNumber}
        merchantPhone={slide.MerchantPhone}
        name={slide.Name}
        merchantIsNearGate={flightGate.includes(slide.MerchantGateProximity)}
        nearGateSplashLabel={nearGateSplashLabel}
        shopLocation={slide.shopLocation}
        openLabel={slide.OpenLabel}
        openingHours={slide.OpeningHours}
        supportsClickAndCollect={slide.SupportsClickAndCollect}
        readMoreLabel={slide.ReadMoreLabel}
        estimatedPublicTime={estimatedPublicTime}
        flightGate={slide.FlightGate}
        showMerchantInfoModal={showMerchantInfoModal}
        isInnerSlide={true}
      />
    )
  })

  return (
    <div className={`tp-merchant-overlay overlay overlay--modal overlay--fixed${isMerchantModalShown ? " is-active" : ""}`}>
      <div className="modal">
        <OutsideClickTrigger
          onOutsideClick={() => {
            showMerchantInfoModal({})
          }}
        >
          <div
            className="close"
            onClick={() => {
              showMerchantInfoModal({})
            }}
          ></div>
          <React.Fragment>
            <div className="tophalfpadding">
              {merchantIsNearGate ? <div className="splash">{nearGateSplashLabel}</div> : null}
              <h2>{name}</h2>
              <ul className="contactlines">
                {shopLocation ? (
                  <li className="atgate">
                    <Svg iconName={"markerpin"} />
                    {shopLocation}
                    {googleMapsLink ? (
                      <span>
                        &ensp;–&ensp;
                        <a className="maps-link" href={googleMapsLink} target={googleMapsLinkTarget}>
                          {googleMapsLinkLabel}
                        </a>
                      </span>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}
                {merchantPhone ? (
                  //if phone, render anchortag, if desktop, render list element
                  windowWidth < 768 ? (
                    <li>
                      <Svg iconName={"mim-phone"} />
                      <a className="contact-link" href={`tel:${merchantPhone}`}>
                        {merchantPhone}
                      </a>
                    </li>
                  ) : (
                    <li>
                      <Svg iconName={"mim-phone"} />
                      {merchantPhone}
                    </li>
                  )
                ) : null}
                {merchantEmail ? (
                  <li>
                    <Svg iconName={"mim-mail"} />
                    <a className="contact-link" href={`mailto:${merchantEmail}`}>
                      {emailCoverLabel || merchantEmail}
                    </a>
                  </li>
                ) : null}
                {supportsClickAndCollect ? (
                  <li>
                    <a href={websiteAdress}>
                      <Svg iconName={"mim-bag"} />
                      {clickAndCollectLabel}
                    </a>
                  </li>
                ) : null}
                {supportsHomeDelivery ? (
                  <li>
                    <Svg iconName={"homedelivery"} />
                    {homeDeliveryLabel}
                  </li>
                ) : null}
                <li className="openinghours">
                  <Svg iconName={"clock3"} />
                  <input type="checkbox" id="openinghoursshown" />
                  <label htmlFor="openinghoursshown">
                    {isFlightDateOlderThanToday && !alwaysOpen ? (
                      <div className="otherdaycontainer">
                        <span className="otherday">{capitalizeFirstLetter(weekdays[estimatedPublicTime.weekday - 1])}</span>

                        <p className="otherdayopening">
                          {openingHoursForTheDay} - {closingHoursForTheDay}
                        </p>
                      </div>
                    ) : alwaysOpen ? (
                      <span>
                        <span className="opennow">{alwaysOpenLabel}</span>
                      </span>
                    ) : merchantIsOpen ? (
                      <span>
                        <span className="opennow">{openLabel}</span> - {closingLabel} {closingHoursForTheDay}
                      </span>
                    ) : (
                      <span>
                        <span className="closednow">{closedLabel}</span> - {openingLabel} {openingHoursForTheDay}
                      </span>
                    )}
                    {alwaysOpen ? null : (
                      <Fragment>
                        <span className={"foldarrow" + (isFlightDateOlderThanToday ? "" : " sameday")}></span>
                        <div className={`dayslist${isFlightDateOlderThanToday ? " no-top-padding" : ""}`}>
                          {getOpeningHoursListWithFlightDayFirst().map((openingHour, index) => {
                            return openingHour
                          })}
                        </div>
                      </Fragment>
                    )}
                  </label>
                </li>
              </ul>
              <div className="infotext">
                <input type="checkbox" id="readmoreisopen" />
                <label htmlFor="readmoreisopen">
                  <div className="rich-text">{ReactHtmlParser(merchantDescription)}</div>
                  <div className="foldicon"></div>
                  <span className="readmoreclosed">{readMoreLabel}</span>
                  <span className="readmoreopen">{readLessLabel}</span>
                </label>
              </div>
            </div>
          </React.Fragment>
          {sameMerchants && sameMerchants.length > 0 ? (
            <div className="carouselcontainer inner-carousel">
              <h5 className="merchanttype">
                {findAllLabel} {name}
              </h5>
              <Slider {...settings}>{sameMerchantsSlider}</Slider>
            </div>
          ) : null}
        </OutsideClickTrigger>
      </div>
    </div>
  )
}

export default MerchantInfoModal
